<dx-popup [wrapperAttr]="{ class: 'adapt-dialog' }"
          [container]="container"
          [resizeEnabled]="allowResize"
          [shading]="modal"
          shadingColor="rgba(0, 0, 0, 0.5)"
          [position]="position"
          [animation]="animationOptions"
          (visibleChange)="onVisibleChanged($event)"
          [minWidth]="minWidth"
          [maxWidth]="maxWidth"
          [width]="width ?? (isMobile ? '95vw' : '80vw')"
          [minHeight]="minHeight"
          [enableBodyScroll]="!isMobile"
          [maxHeight]="maxHeightValue"
          (onInitialized)="onInitialized($event)"
          (onShown)="onShown()"
          [showTitle]="!minimal"
          [fullScreen]="fullscreen"
          [dragEnabled]="!fullscreen"
          height="auto">
    <div *dxTemplate="let data of 'title'">
        <div class="mt-1 mb-0 d-flex flex-row justify-content-between align-items-center dialog-title"
             [ngClass]="{ 'mt-2 mb-1': !expandable }">
            <ng-content select="[adapt-dialog-title]"></ng-content>

            <div class="d-flex align-items-center ms-2">
                <ng-content select="[adapt-dialog-menu]"></ng-content>

                @if (showHelpButton && contextSidebarHasContent) {
                    <button adaptButton="help"
                            class="ms-2"
                            [ngClass]="{ active: contextSidebarVisible }"
                            data-test="dialog-help-button"
                            (click)="toggleHelp()"></button>
                }

                @if (expandable) {
                    <button [adaptButtonIcon]="fullscreen ? 'fal fa-compress-alt' : 'fal fa-expand-alt'"
                            [adaptTooltip]="fullscreen ? 'Minimise' : 'Maximise'"
                            [title]="fullscreen ? 'Minimise' : 'Maximise'"
                            class="btn btn-blank btn-fullscreen"
                            data-test="dialog-fullscreen-toggle"
                            (click)="onFullscreenToggle()"></button>
                }

                @if (showCancelButtonOnTitle && !disallowCancel) {
                    <button class="btn btn-blank btn-cancel"
                            adaptButtonIcon="fal fa-times"
                            data-test="dialog-close-button"
                            (click)="emitCancelEvent()"></button>
                }
            </div>
        </div>
    </div>
    <div *dxTemplate="let data of 'content'"
         class="d-flex flex-column justify-content-between">
        @if (errorMessage) {
            <div class="m-1 alert alert-danger"
                 role="alert"
                 data-test="dialog-error">
                <span [textContent]="errorMessage"></span>
            </div>
        }
        <div class="dialog-content d-flex flex-column h-100 p-0"
             [ngClass]="{ 'fit-height': fitHeight }">
            @if (allowMouseWheelContentScroll) {
                <dx-scroll-view [useNative]="true"
                                class="h-100">
                    <div [ngClass]="minimal || !padding ? 'p-0' : 'p-3'">
                        <ng-container [ngTemplateOutlet]="projectedContent"></ng-container>
                    </div>
                </dx-scroll-view>
            } @else {
                <div [ngClass]="minimal || !padding ? 'p-0' : 'p-3'">
                    <ng-container [ngTemplateOutlet]="projectedContent"></ng-container>
                </div>
            }
        </div>
        <div class="dialog-footer flex-shrink-0"
             [ngClass]="minimal || hideFooter ? 'd-none' : 'd-flex'">
            <ng-content select="[adapt-dialog-footer]"></ng-content>
        </div>
    </div>
</dx-popup>

@if (articleId !== undefined) {
    <adapt-context-sidebar-implementation-kit [articleId]="articleId"
                                              context="dialog"></adapt-context-sidebar-implementation-kit>
}

<ng-template #projectedContent>
    <ng-content select="[adapt-dialog-content]"></ng-content>
</ng-template>
